// extracted by mini-css-extract-plugin
export default {"adminRootContainer":"AdminRootLayout_adminRootContainer__mAKAH","contentContainer":"AdminRootLayout_contentContainer__uErhn","mainContent":"AdminRootLayout_mainContent__mUpZZ"};